const WORKLET_RUN_POLLING_START_PERIOD_MS = 100;
const WORKLET_RUN_POLLING_PERIOD_MULTIPLIER = 2;
const WORKLET_RUN_POLLING_TIMEOUT_MS = 300 * 1000; // 5 minutes

export {
  WORKLET_RUN_POLLING_START_PERIOD_MS,
  WORKLET_RUN_POLLING_PERIOD_MULTIPLIER,
  WORKLET_RUN_POLLING_TIMEOUT_MS,
};
